module.exports = __webpack_public_path__ + "static/media/loginbackground.85e9895f.png";